import React from 'react';
import Skeleton from '@comp/skeletonBase';
import { Block } from '@comp/crRender';
import '../../../../providers/profile/style.css';

const ProviderDetailsSkeleton = ({ isRender }) => {
    return (
        <Block isRender={!!isRender} className="hospital-profile-container">
            {/* Main Content Grid */}
            <div className="hospital-profile-grid">
                {/* Left Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    {/* Basic Information Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="40%"
                            height="24px"
                            style={{ marginBottom: '20px' }}
                        />
                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '16px' }}>
                            <Skeleton
                                variant="rounded"
                                width="100px"
                                height="100px"
                                style={{ borderRadius: '8px' }}
                            />
                            <div style={{ flex: 1 }}>
                                <Skeleton variant="text" width="70%" height="20px" style={{ marginBottom: '12px' }} />
                                <Skeleton variant="text" width="50%" height="16px" />
                            </div>
                        </div>
                        <Skeleton variant="text" width="100%" height="14px" style={{ marginBottom: '8px' }} />
                        <Skeleton variant="text" width="95%" height="14px" style={{ marginBottom: '8px' }} />
                        <Skeleton variant="text" width="85%" height="14px" />
                    </div>

                    {/* Accreditations Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="35%"
                            height="20px"
                            style={{ marginBottom: '16px' }}
                        />
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            <Skeleton variant="rounded" width="80px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="100px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="90px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="110px" height="32px" style={{ borderRadius: '20px' }} />
                        </div>
                    </div>

                    {/* Advanced Technologies Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="45%"
                            height="20px"
                            style={{ marginBottom: '16px' }}
                        />
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            <Skeleton variant="rounded" width="120px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="95px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="105px" height="32px" style={{ borderRadius: '20px' }} />
                        </div>
                    </div>

                    {/* Media Row - Gallery and Video */}
                    <div className="media-row" style={{ display: 'flex', gap: '24px' }}>
                        {/* Gallery */}
                        <div style={{
                            flex: 1,
                            background: '#ffffff',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                        }}>
                            <Skeleton
                                variant="text"
                                width="30%"
                                height="20px"
                                style={{ marginBottom: '16px' }}
                            />
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
                                <Skeleton variant="rounded" width="100%" height="100px" style={{ borderRadius: '8px' }} />
                                <Skeleton variant="rounded" width="100%" height="100px" style={{ borderRadius: '8px' }} />
                                <Skeleton variant="rounded" width="100%" height="100px" style={{ borderRadius: '8px' }} />
                            </div>
                        </div>

                        {/* Video */}
                        <div style={{
                            flex: 1,
                            background: '#ffffff',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                        }}>
                            <Skeleton
                                variant="text"
                                width="30%"
                                height="20px"
                                style={{ marginBottom: '16px' }}
                            />
                            <Skeleton variant="rounded" width="100%" height="200px" style={{ borderRadius: '8px' }} />
                        </div>
                    </div>

                    {/* Testimonials Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="30%"
                            height="20px"
                            style={{ marginBottom: '16px' }}
                        />
                        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                            <Skeleton variant="circular" width="50px" height="50px" />
                            <div style={{ flex: 1 }}>
                                <Skeleton variant="text" width="40%" height="16px" style={{ marginBottom: '8px' }} />
                                <Skeleton variant="text" width="30%" height="14px" />
                            </div>
                        </div>
                        <Skeleton variant="text" width="100%" height="14px" style={{ marginBottom: '8px' }} />
                        <Skeleton variant="text" width="90%" height="14px" />
                    </div>

                    {/* Refund Policy Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="35%"
                            height="20px"
                            style={{ marginBottom: '16px' }}
                        />
                        <Skeleton variant="text" width="100%" height="14px" style={{ marginBottom: '8px' }} />
                        <Skeleton variant="text" width="95%" height="14px" style={{ marginBottom: '8px' }} />
                        <Skeleton variant="text" width="88%" height="14px" />
                    </div>
                </div>

                {/* Right Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    {/* Contact Information Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="50%"
                            height="20px"
                            style={{ marginBottom: '20px' }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <Skeleton variant="circular" width="20px" height="20px" />
                                <Skeleton variant="text" width="70%" height="14px" />
                            </div>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <Skeleton variant="circular" width="20px" height="20px" />
                                <Skeleton variant="text" width="75%" height="14px" />
                            </div>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <Skeleton variant="circular" width="20px" height="20px" />
                                <Skeleton variant="text" width="65%" height="14px" />
                            </div>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <Skeleton variant="circular" width="20px" height="20px" />
                                <Skeleton variant="text" width="80%" height="14px" />
                            </div>
                        </div>
                    </div>

                    {/* Top Rated Doctors Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="45%"
                            height="20px"
                            style={{ marginBottom: '20px' }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                <Skeleton variant="circular" width="60px" height="60px" />
                                <div style={{ flex: 1 }}>
                                    <Skeleton variant="text" width="70%" height="16px" style={{ marginBottom: '8px' }} />
                                    <Skeleton variant="text" width="50%" height="14px" />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                <Skeleton variant="circular" width="60px" height="60px" />
                                <div style={{ flex: 1 }}>
                                    <Skeleton variant="text" width="65%" height="16px" style={{ marginBottom: '8px' }} />
                                    <Skeleton variant="text" width="55%" height="14px" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Specialties Card */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Skeleton
                            variant="text"
                            width="35%"
                            height="20px"
                            style={{ marginBottom: '16px' }}
                        />
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            <Skeleton variant="rounded" width="90px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="110px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="100px" height="32px" style={{ borderRadius: '20px' }} />
                            <Skeleton variant="rounded" width="85px" height="32px" style={{ borderRadius: '20px' }} />
                        </div>
                    </div>
                </div>
            </div>
        </Block>
    );
};

export default ProviderDetailsSkeleton;
